import React, { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./screens/landingPage/landingPage";
import BookingForm from "./screens/bookingForm/bookingForm";
import PickupInfo from "./screens/pickupInfo/pickupInfo";
import BookingThankyouPage from "./screens/bookingThankyouPage/bookingThankyouPage";
import { LoadScript } from "@react-google-maps/api";
import BookingPayment from "./screens/bookingPayment/bookingPayment";
import DriverBooking from "./screens/driverBooking/driverBooking";
const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return children;
};

const App = () => (
  // <div>
  //   <h1>hello</h1>
  // </div>
  <BrowserRouter>
    <Wrapper>
      <LoadScript
        googleMapsApiKey="AIzaSyBxuHIiv4wnRnSuW9Si4LFTZYlFWHelbks"
        libraries={["places"]}
      >
        <Routes>
          <Route path="/" element={<LandingPage />}></Route>
          <Route path="/booking" element={<BookingForm />}></Route>
          <Route path="/pickup-info" element={<PickupInfo />}></Route>
          <Route path="/payment" element={<BookingPayment />}></Route>
          <Route
            path="/booking-confirm"
            element={<BookingThankyouPage />}
          ></Route>
          <Route path="/driverBooking" element={<DriverBooking />}></Route>
        </Routes>
      </LoadScript>
    </Wrapper>
  </BrowserRouter>
);
export default App;
